import { configureOpenApiClients } from '../../api/configure';
import { externalCampaignActivateExternalCampaign } from '../../api/v1';

export const useExternalCampaignsApi = (token: string) => {
  configureOpenApiClients();

  const activateExternalCampaign = async (campaign: string, orderLineId: string) => {
    const body = { campaign, orderLineId };
    return await externalCampaignActivateExternalCampaign({
      body,
      headers: { authorization: 'Bearer ' + token },
    });
  };
  return {
    activateExternalCampaign,
  };
};
